import { patchArticleFeedback } from 'core_main/api/articles';
import { PublicCallback } from 'globals/types';
import { validatePatchArticleFeedbackParameters } from './helpers';
import { UpdateArticleFeedbackParameters } from './types';

export const updateArticleFeedback = (
  parameters: UpdateArticleFeedbackParameters,
  cb?: PublicCallback,
) => {
  const validationError = validatePatchArticleFeedbackParameters(parameters);
  if (validationError) {
    return Promise.reject(validationError);
  }
  return patchArticleFeedback({
    articleId: parameters.articleId,
    id: parameters.feedbackId,
    suggestedReasons: parameters.suggestedReasons || [],
    writtenFeedback: parameters.writtenFeedback || '',
  }).then((response) => {
    if (cb) cb(response);
  });
};
